import {
  Collapse,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  styled,
  Typography,
  useTheme,
} from "@mui/material";
import ExpandLessIcon from "assets/icons/ExpandLessIcon";
import ExpandMoreIcon from "assets/icons/ExpandMoreIcon";
import { Field, useFormikContext } from "formik";
import invoiceInformationItems from "assets/js/invoiceInformationItems";
import { InvoiceSwitch } from "components/Input/switch";

import { forwardRef, memo, useState } from "react";
import shortid from "shortid";
import {
  StyledInputBase as BaseInput,
  StyledTextareaAutosize as TextareaAutosize,
} from "components/Input/styled";
// import TextInput from "components/Input/TextInput";

const FactorSettingInfoContainer = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  // justifyContent: 'space-between'
}));
const StyledInputBase = styled(BaseInput)(({ theme }) => ({
  width: "80%",
  // justifyContent: 'space-between'
}));
const FactorSectionItem = styled("div")(({ theme }) => ({
  height: "12%",
}));
const TitleItem = styled(FactorSectionItem)(({ theme }) => ({
  borderBottom: `1px solid #ABBACC`,
  minHeight: "40px",
}));

const StyledListItemButton = styled(ListItemButton)(
  ({ theme, active }: { theme?: ThemeObjType; active?: boolean }) => ({
    height: "50px",
    margin: "8px 0 8px 0",
    padding: "12px",
    backgroundColor: active ? "none" : "#F9FBFC",
    "&:hover": {
      backgroundColor: "#EBF0FF52",
    },
  })
);

const StyledListItemIcon = styled(ListItemIcon)({
  minWidth: "30px",
});

const StyledListItemText = styled(ListItemText)({
  textAlign: "right",
});

const SubItem = styled("div")({
  display: "flex",
  padding: "12px",
  alignItems: "center",
});

const SubListItemText = styled(ListItemText)({
  paddingRight: "12px",
});

const InfoItem = memo(({ data, listRef }: { data: (typeof invoiceInformationItems)[0]; listRef: any }) => {
  const [open, setOpen] = useState(false);
  const theme = useTheme();
  const Icon = data.icon;
  return (
    <>
      <StyledListItemButton disableRipple active={open} onClick={() => setOpen(!open)}>
        <StyledListItemIcon>
          <Icon active={open} />
        </StyledListItemIcon>
        <StyledListItemText>
          <Typography
            variant="body2"
            color={open ? theme.palette.text.primary : theme.palette.text.secondary}
          >
            {data.title}
          </Typography>
        </StyledListItemText>
        {open ? <ExpandLessIcon /> : <ExpandMoreIcon />}
      </StyledListItemButton>
      <Collapse in={open} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>
          {/* @ts-ignore */}
          {data.subItems &&
            data?.subItems.map((subItem) => <SubInput key={shortid.generate()} data={subItem} />)}
        </List>
      </Collapse>
    </>
  );
});

const SubInput = memo(
  ({
    data,
  }: {
    data: {
      name: string;
      title: string;
      input: boolean;
    };
  }) => {
    const theme = useTheme();

    const formikContext = useFormikContext();
    const { values }: any = formikContext;
    // @ts-ignore
    const [disabled, setDisabled] = useState(
      !data.input ? (values[data.name] ? false : true) : values[`${data.name}Active`] ? false : true
    );

    return (
      <SubItem>
        <SubListItemText>
          {data.input && (
            <Field name={data.name} as={StyledInputBase} disabled={disabled} placeholder={data.title} />
          )}
          {!data.input && (
            <Typography
              color={disabled ? theme.palette.text.disabled : theme.palette.text.primary}
              variant="body2"
            >
              {data.title}
            </Typography>
          )}
        </SubListItemText>
        <InvoiceSwitch
          checked={!disabled}
          onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
            setDisabled(!disabled);
            if (!data.input) {
              formikContext.setFieldValue(data.name, disabled);
            } else {
              formikContext.setFieldValue(`${data.name}Active`, disabled);
            }
          }}
        />
      </SubItem>
    );
  }
);

const FactorSettingInfoList = forwardRef(({ prop }: { prop?: any }, ref) => {
  const theme = useTheme();

  return (
    <FactorSettingInfoContainer>
      <TitleItem>
        <Typography variant="body2">نمایش اطلاعات فاکتور</Typography>
      </TitleItem>
      {/* @ts-ignore */}
      <List ref={ref} component="div" disablePadding>
        {invoiceInformationItems.map((item, i) => (
          <InfoItem key={i} listRef={ref} data={item} />
        ))}
      </List>
      {/* <StyledListItemButton disableRipple>
                <StyledListItemIcon>
                    <CurrencyIcon />
                </StyledListItemIcon>
                <StyledListItemText>
                    <Typography variant='body2'
                        color={theme.palette.text.secondary}>
                        واحد پول
                    </Typography>
                </StyledListItemText>
                <TextedSwitch />
            </StyledListItemButton> */}
      <Field minRows={3} name="description" as={TextareaAutosize} placeholder="توضیحات فاکتور" />
    </FactorSettingInfoContainer>
  );
});

export default FactorSettingInfoList;
